
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeaveAllocationDialog extends Serenity.EntityDialog<LeaveAllocationRow, any> {
        protected getFormKey() { return LeaveAllocationForm.formKey; }
        protected getIdProperty() { return LeaveAllocationRow.idProperty; }
        protected getLocalTextPrefix() { return LeaveAllocationRow.localTextPrefix; }
        protected getService() { return LeaveAllocationService.baseUrl; }
        protected getDeletePermission() { return LeaveAllocationRow.deletePermission; }
        protected getInsertPermission() { return LeaveAllocationRow.insertPermission; }
        protected getUpdatePermission() { return LeaveAllocationRow.updatePermission; }

        protected form = new LeaveAllocationForm(this.idPrefix);

    }
}